"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoinSection = exports.CoinName = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Wrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 32px;
  cursor: pointer;

  &:hover {
    background: lightgrey;
  }
`;
exports.CoinName = styled_components_1.default.div `
  flex: 1;
  margin-left: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
`;
exports.CoinSection = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  margin-right: 8px;
`;
//# sourceMappingURL=styled.js.map